module.exports = __webpack_public_path__ + "img/iconhistory.b2c1ac9a.png";